import { render, staticRenderFns } from "./UpdateInformation.vue?vue&type=template&id=4d889a00&scoped=true&"
import script from "./UpdateInformation.vue?vue&type=script&lang=ts&"
export * from "./UpdateInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d889a00",
  null
  
)

export default component.exports